import { render } from "./Vikipedia.vue?vue&type=template&id=5136ebc7&scoped=true"
import script from "./Vikipedia.vue?vue&type=script&lang=js"
export * from "./Vikipedia.vue?vue&type=script&lang=js"

import "./Vikipedia.vue?vue&type=style&index=0&id=5136ebc7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5136ebc7"]])

export default __exports__